import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./Layout.css";

const Layout = ({ children, activePage }) => {
  const [user, setUser] = useState({ name: "", role: "" });

  useEffect(() => {
    const userData = localStorage.getItem("userDATA");
    if (userData) {
      setUser(JSON.parse(userData));
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("userDATA");
    window.location.href = "/";
  };

  return (
    <div className="app">
      <header className="header">
        <div className="logo-section">
          <h1 className="header-logo">Forza Logistics</h1>
        </div>
        <div className="header-content">
          <div className="profile-section">
            <div className="profile-icon">
              <span>{user.name ? user.name.charAt(0).toUpperCase() : "U"}</span>
            </div>
            <span className="profile-name">{user.name || "User"}</span>
          </div>
          <button className="logout-btn" onClick={handleLogout}>
            Logout
          </button>
        </div>
      </header>

      <nav className="horizontal-nav">
        <div className="nav-container">
          <Link
            to="/dashboard"
            className={activePage === "dashboard" ? "active" : ""}
          >
            DASHBOARD
          </Link>
          <Link
            to="/employees"
            className={activePage === "employees" ? "active" : ""}
          >
            EMPLOYEES
          </Link>
          
          <Link
            to="/trucks"
            className={activePage === "trucks" ? "active" : ""}
          >
            TRUCKS
          </Link>
          <Link
            to="/new-weekly-schedule"
            className={activePage === "new-schedule" ? "active" : ""}
              // className={`${activePage === "new-schedule" ? "active" : ""} disabled-link`}
          >
            Create SCHEDULE +
          </Link>
          <Link
            to="/weekly-schedules"
            className={activePage === "weekly-schedules" ? "active" : ""}
            //  className={`${activePage === "weekly-schedules" ? "active" : ""} disabled-link`}
          >
            WEEKLY SCHEDULES
          </Link>
        </div>
      </nav>

      <main className="content">{children}</main>
    </div>
  );
};

export default Layout;
